var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"article"},[_c('iframe',{staticStyle:{"width":"100%"},attrs:{"src":"https://mp.weixin.qq.com/s/M5XOSh_ZgwgaGe3PTFUDzg"}})])
}]

export { render, staticRenderFns }